import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import { captureFromLocation } from "./lib/signedLink";

/* 署名付きリンクのトークンを URL から抜き取る（REC-443）。
   **ルーターが URL を読む `new Vue` より前に。** 画面の読み込みや API の通信が
   始まる前に消しておけば、アドレスバー（共有・コピーされる URL）と、この後の
   通信の Referer に載らない */
captureFromLocation(window);

Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
